/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenericDialogModule } from 'src/app/common/generic-dialog/generic-dialog.module';
import { UtilityComponentsModule } from 'src/app/common/utility-components/utility-components.module';
import { MaterialModule } from 'src/app/common/material/material-module';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';
import { SharedUIMaterialModule } from 'src/app/shared/ui/material/shared-ui-material.module';
import { OrganizationAppEditorComponent } from './components/organization-app-editor/organization-app-editor.component';
import { OrganizationService } from './services/organization.service';
import { AppSecretDialog } from './components/app-secret-dialog/app-secret-dialog.component';
import { OrganizationAppInfoComponent } from './components/organization-app-info/organization-app-info.component';
import { OrganizationAppProjectsComponent } from './components/organization-app-projects/organization-app-projects.component';
import { AddEditOrganizationAppComponent } from './components/add-edit-organization-app/add-edit-organization-app.component';
import { PresentationModule } from 'src/app/common/presentation-components/presentation.module';

@NgModule({
	declarations: [
		OrganizationAppEditorComponent,
		AppSecretDialog,
		OrganizationAppInfoComponent,
		OrganizationAppProjectsComponent,
		AddEditOrganizationAppComponent,
		AppSecretDialog,
	],
	imports: [
		CommonModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		GenericDialogModule,
		UtilityComponentsModule,
		DialogReusableModule,
		SharedUIMaterialModule,
		PresentationModule,
	],
	providers: [OrganizationService],
	exports: [OrganizationAppEditorComponent, AddEditOrganizationAppComponent, AppSecretDialog],
})
export class OrganizationsModule {}
